import React, { useState } from "react";
import { AppBar } from "react-admin";
import { Box, TextField, Button, CircularProgress } from "@material-ui/core";
import MyUserMenu from "./MyUserMenu";
import { useExchangeRate } from "../context/ExchangeRateContext";
import { toast } from "react-toastify";

const MyAppBar = (props) => {
  const { exchangeRate, setExchangeRate } = useExchangeRate();
  const [loading, setLoading] = useState(false);

  const handleUpdateToken = async () => {
    setLoading(true);
    try {
      const res = await fetch("/private/user/update-user-token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${await localStorage.getItem("accessToken")}`,
        },
      });

      const result = await res.json();

      if (!res.ok) throw new Error(result.msg || "Request failed");

      toast.success("✅ Token updated successfully!");
    } catch (err) {
      console.error("Failed to update token:", err);
      toast.error("❌ Token update failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppBar {...props} userMenu={<MyUserMenu />}>
      <Box flex="1" />
      <Box display="flex" alignItems="center" mr={2}>
        <TextField
          placeholder="Exchange Rate"
          value={exchangeRate}
          onChange={(e) => {
            const value = e.target.value;
            if (value === '' || /^(\d+(\.\d*)?|\.\d+)$/.test(value)) {
              setExchangeRate(value);
            }
          }}
          size="small"
          variant="outlined"
          style={{ width: 130, backgroundColor: 'white' }}
          inputProps={{
            inputMode: 'decimal',
            pattern: '^\\d+(\\.\\d+)?$',
            style: { padding: '6px 8px' }
          }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpdateToken}
          style={{ marginLeft: 12, minWidth: 130 }}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Update Token"
          )}
        </Button>
      </Box>
    </AppBar>
  );
};

export default MyAppBar;
